<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 9.63211 0.488749 11.1501 1.32787 12.4155C1.34287 12.3904 1.36114 12.3668 1.38271 12.3452L5.8656 7.86231C5.97333 7.75458 5.97111 7.57768 5.86064 7.46721L4.20841 5.81498C4.13545 5.74257 4.0943 5.6444 4.09437 5.54291C4.09454 5.3362 4.26227 5.17297 4.46902 5.17831L10.7527 5.4235C10.8535 5.42397 10.9509 5.46506 11.0228 5.5375C11.0928 5.60907 11.1323 5.70471 11.1328 5.80356L11.4089 12.0564C11.4116 12.1599 11.3713 12.2588 11.2976 12.3297C11.1505 12.4712 10.9135 12.4637 10.7682 12.313L9.12002 10.6648C9.00955 10.5543 8.83265 10.5521 8.72492 10.6599L4.29341 15.0914C5.40149 15.6717 6.66241 16 8 16Z"
          fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconInvestSell"
}
</script>

<style scoped>

</style>